import { useState } from "react";
import type { UploadPlan } from "@titancloud/shared";

interface JunkFilterReportProps {
  plan: UploadPlan;
}

export function JunkFilterReport({ plan }: JunkFilterReportProps) {
  const [expanded, setExpanded] = useState(false);
  const junkFiles = plan.files.filter((f) => f.isJunk);

  return (
    <div className="rounded-lg border border-yellow-700/50 bg-yellow-900/10">
      <button
        className="flex w-full items-center justify-between px-4 py-3 text-sm"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2 text-yellow-300">
          <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
          <span>
            <strong>{plan.excludedFiles}</strong> junk items excluded
          </span>
        </div>
        <svg
          className={`h-4 w-4 text-gray-400 transition-transform ${expanded ? "rotate-180" : ""}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
        </svg>
      </button>

      {expanded && (
        <div className="max-h-40 overflow-y-auto border-t border-yellow-700/30 px-4 py-2">
          {junkFiles.map((f, i) => (
            <div key={i} className="flex items-center justify-between py-1 text-xs">
              <span className="truncate text-gray-400 font-mono">{f.relativePath}</span>
              <span className="ml-2 flex-shrink-0 text-yellow-500">{f.junkReason}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
